// src/views/tables/AirtelPaymentBankClient.js
import React, { useEffect, useState, useMemo } from 'react';
import axios from 'axios';
import ReactTable from 'react-table-v6';
import { Button } from 'reactstrap';
import { Link, useNavigate } from 'react-router-dom';
import * as XLSX from 'xlsx';
import ComponentCard from '../../components/ComponentCard';

const AirtelPaymentBankClient = () => {
  const [projects, setProjects] = useState([]);
  const user = JSON.parse(localStorage.getItem('user'));
  const navigate = useNavigate();

  const fetchOldProjects = async () => {
    try {
      let response;

      if (user?.type === 'vendor') {
        response = await axios.get('https://amaapi.outdoorooh.com/api/vendor_old_projects');
      } else if (user?.type === 'State Head') {
        response = await axios.get('https://amaapi.outdoorooh.com/api/statehead_old_projects');
      } else if (user?.type === 'client') {
        response = await axios.get('https://amaapi.outdoorooh.com/api/fresh-site-client-project');
      } else {
        response = await axios.get('https://amaapi.outdoorooh.com/api/fresh-site-client-project');
      }

      if (response?.data?.data) {
        const sorted = response.data.data.sort((a, b) => a.site_name.localeCompare(b.site_name));
        setProjects(sorted);
      }
    } catch (error) {
      console.error('Error fetching old projects:', error);
    }
  };

  useEffect(() => {
    if (!user?.token) {
      navigate('/auth/loginformik');
      return;
    }
    fetchOldProjects();
  }, []);

  const exportToExcel = () => {
    const worksheet = XLSX.utils.json_to_sheet(projects);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Old Projects');
    XLSX.writeFile(workbook, 'old_projects.xlsx');
  };
  const defaultFilterMethod = (filter, row) => {
    return String(row[filter.id]).toLowerCase().includes(filter.value.toLowerCase());
  };
  const tableData = useMemo(() => {
    return projects.map((p) => ({
      ...p,
      site_name: (
        <Link to={`/airtel-payment-bank-client-detail/${p.id}`} style={{ textDecoration: 'none' }}>
          {p.site_name}
        </Link>
      ),
      code: (
        <Link to={`/airtel-payment-bank-client-detail/${p.id}`} style={{ textDecoration: 'none' }}>
          {p.code}
        </Link>
      ),
    }));
  }, [projects]);

  return (
    <div>
      {/* Buttons */}
      <div className="d-flex justify-content-between mb-2" style={{ width: '100%' }}>
        <div>
          <Button color="primary" onClick={() => navigate('/tables/data-table')}>
            KolKata Projects
          </Button>{' '}
         <Button
                   color="primary"
                   onClick={() => navigate('/tables/old-projects')}
                 >
                   Scam Projects
                 </Button>{' '}
          <Button color="success" onClick={exportToExcel}>
            Export to Excel
          </Button>{' '}
          
        </div>
      </div>

      {/* Table */}
      <ComponentCard title="Airtel Payment Bank Campaign">
        <ReactTable
          data={tableData}
          columns={[
            // {
            //   Header: 'ID',
            //   accessor: 'id',
            //   filterMethod: (filter, row) => {
            //     return row[filter.id].toString().toLowerCase().includes(filter.value.toLowerCase());
            //   },
            // },
            {
              Header: 'Site Name',
              accessor: 'site_name',
              filterMethod: (filter, row) => {
                // Handle case where row[filter.id] is a component
                const rowValue =
                  typeof row[filter.id] === 'string'
                    ? row[filter.id]
                    : row[filter.id]?.props?.children || '';

                return rowValue.toLowerCase().includes(filter.value.toLowerCase());
              },
            },
            {
              Header: 'Code',
              accessor: 'code',
              filterMethod: (filter, row) => {
                const rowValue =
                  typeof row[filter.id] === 'string'
                    ? row[filter.id]
                    : row[filter.id]?.props?.children || '';
                return rowValue.toLowerCase().includes(filter.value.toLowerCase());
              },
            },
            // {
            //   Header: 'Project',
            //   accessor: 'project',
            //   filterMethod: (filter, row) => {
            //     return row[filter.id].toString().toLowerCase().includes(filter.value.toLowerCase());
            //   },
            // },
            // {
            //   Header: 'City',
            //   accessor: 'city',
            // },
            // {
            //   Header: 'District',
            //   accessor: 'district',
            // },
            {
              Header: 'State',
              accessor: 'state',
            },
            {
              Header: 'Zone',
              accessor: 'zone',
            },
            {
              Header: 'Vendor Name',
              accessor: 'vendor_name',
              filterMethod: (filter, row) => {
                // Handle case where row[filter.id] is a component
                const rowValue =
                  typeof row[filter.id] === 'string'
                    ? row[filter.id]
                    : row[filter.id]?.props?.children || ''; // Fallback to an empty string if props.children is undefined

                return rowValue.toLowerCase().includes(filter.value.toLowerCase());
              },
            },
            {
              Header: 'Length',
              accessor: 'length',
            },
            {
              Header: 'Width',
              accessor: 'width',
            },
            {
              Header: 'Total',
              accessor: 'total',
            },
          ]}
          defaultPageSize={100}
          pageSizeOptions={[10, 20, 100, 200, 500, 2500]}
          showPaginationBottom
          className="-striped -highlight"
          filterable
          defaultFilterMethod={defaultFilterMethod}
        />
      </ComponentCard>
    </div>
  );
};

export default AirtelPaymentBankClient;
